import { useOnOutsideClick } from "./useOnOutsideClick";
export { useOnOutsideClick };
export default useOnOutsideClick;
